import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const CardIcon = ({ className , name , height , width  })=>/*#__PURE__*/ React.createElement(Icon, {
        className: classnames('card-icon', className),
        height: height,
        width: width,
        name: name
    })
;

export { CardIcon as default };
//# sourceMappingURL=CardIcon.js.map
